import { servicesPlugin, UIRouterReact, UrlService } from "@uirouter/react";

import { isDevToolsOpen } from "app/services/dev-toggle/devToggle";
import { swHashLocationPlugin } from "single-spa/react-app/router/plugins/SWHashLocationPlugin";

export let router: UIRouterReact;

// @ts-ignore FIXME: strict migration - 'router' is used before being assigned — module-init UrlService is constructed with the pre-initRouter() undefined value by design
export const locationService = new UrlService(router);

export const initRouter = () => {
    router = new UIRouterReact();
    router.plugin(servicesPlugin);
    router.plugin(swHashLocationPlugin);
    if (window.location.host.includes(".sandbox.") || window.location.host.includes(".production.")) {
        (window as any).router = router;
    }
    if (isDevToolsOpen()) {
        void import("@uirouter/visualizer").then(({ Visualizer }) => {
            router.plugin(Visualizer);
        });
    }
    return router;
};

export const disposeRouter = () => {
    router.dispose();
    // @ts-ignore FIXME: strict migration - Type 'null' is not assignable to type 'UIRouterReact' — widening 'router' to nullable would cascade to all consumers; cleared here only on dispose
    router = null;
};

// RIPNG: im not sure we still need this
// $rootScope.$on("navChangeNewPageView", () => {
//     swRedux.dispatch(applyCurrentPage());
// });
